"use strict";
/**
 *  @internal
 *  @module Types
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferMatchAmount = void 0;
var TransferMatchAmount;
(function (TransferMatchAmount) {
    TransferMatchAmount["MAXIMUM"] = "maximum";
    TransferMatchAmount["MINIMUM"] = "minimum";
    TransferMatchAmount["EXACT"] = "exact";
})(TransferMatchAmount = exports.TransferMatchAmount || (exports.TransferMatchAmount = {}));
//# sourceMappingURL=Configuration.js.map